import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// let myModal = null;

export default class extends Controller {
  static targets = [ "brandField" ];
  connect () {
    if (this.brandFieldTarget) {
      new TomSelect(this.brandFieldTarget, {
        plugins: {
          remove_button:{
            title:"Remove this item",
          }
        },
        maxItems: 3,
        create: function(input, _callback) {
          document.getElementById("brand-new").style.display = "block";
        }
      });
    }
  }

}